// extracted by mini-css-extract-plugin
export var addressFields = "_i9-0";
export var animationContainer = "_i9-1";
export var footer = "_i9-2";
export var lineItems = "_i9-3";
export var modalContent = "_i9-4";
export var orderName = "_i9-5";
export var strong = "_i9-6";
export var warning = "_i9-7";